import { useDispatch, useSelector } from 'react-redux';
import './css/dashboard.css';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { changeNum } from './common/function';
import List from './component/list/list';
import Chart from 'react-apexcharts';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp } from "@fortawesome/free-solid-svg-icons";

function Dashboard() {
    let dispatch = useDispatch()
    let navigate = useNavigate()

    let MyData = useSelector((state) => { return state.MyData })

    useEffect(() => {
        dispatch(change_Current_Location("대시보드"))
        dispatch(changeHeaderTitle({
            mainTitle: "대시보드",
            subTitle: ""
        }))
    }, [])

    const [page, setPage] = useState(1)
    const [combineData, setCombineData] = useState([])
    const [agentDashboardToday, setAgentDashboardToday] = useState([])
    const [agentDashboardSum, setAgentDashboardSum] = useState([])
    const [agentSettlement, setAgentSettlement] = useState([])

    useEffect(() => {
        getAgentDashboard()
        getAgentSettlement()

        const interval = setInterval(() => {
            getAgentDashboard();
        }, 10000);

        // 클린업 함수
        return () => {
            clearInterval(interval);
        };
    }, [])

    // 함수 이름이 컴포넌트와 같은 이름이어서 충돌 우려가 있으므로 변경
    const getAgentDashboard = async () => {
        // await axios.get(process.env.REACT_APP_API + "/api/agent-dashboard", {
        //     withCredentials: true,
        // }).then((response) => {
        //     let tmp = response?.data
        //     if (tmp?.code < 2000) {
        //         // console.log(tmp)
        //         setAgentDashboardToday(tmp?.data?.today[0] ?? [])
        //         setAgentDashboardSum(tmp?.data?.sum[0] ?? [])
        //     } else if (tmp?.code === 9999) {
        //         navigate('/')
        //     }
        // }).catch(error => {
        //     console.error(error);
        //     navigate("/");
        // });
    }

    const getAgentSettlement = async () => {
        // await axios.get(process.env.REACT_APP_API + "/api/agent-settlement/month", {
        //     withCredentials: true,
        // }).then((response) => {
        //     let tmp = response?.data
        //     if (tmp?.code < 2000) {
        //         console.log(tmp)
        //         setAgentSettlement(tmp?.data ?? [])
        //     } else if (tmp?.code === 9999) {
        //         navigate('/')
        //     }
        // }).catch(error => {
        //     console.error(error);
        //     navigate("/");
        // });
    }

    // ----------------------------
    // 차트용 State (일별 / 월별)
    // ----------------------------
    const [dailyData, setDailyData] = useState([]);
    const [monthData, setMonthData] = useState([]);
    const [reload, setReload] = useState(false);

    // ----------------------------
    // 기간 선택 (monthly: 일별 / yearly: 월별)
    // ----------------------------
    const [period, setPeriod] = useState('monthly');


    // ▼ 추가: 고를 수 있는 연도 목록
    const [yearList, setYearList] = useState([])

    // ----------------------------
    // 년/월 select 동적 생성
    // ----------------------------
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    for (let y = 2024; y <= currentYear; y++) {
        yearList.push(y);
    }
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    // 월 리스트 동적 생성
    const getMonthList = () => {
        const monthArray = [];
        const limit = selectedYear === currentYear ? currentMonth : 12;
        for (let m = 1; m <= limit; m++) {
            monthArray.push(m);
        }
        return monthArray;
    };
    const monthList = getMonthList();

    useEffect(() => {
        getMerchantList();
    }, [reload, period, selectedYear, selectedMonth]);

    // ----------------------------
    // (2-1) 가맹점 정산 리스트
    // ----------------------------
    const getMerchantList = async () => {
        // try {
        //     const response = await axios.get(process.env.REACT_APP_API + '/api/settlement/calandar', {
        //         withCredentials: true,
        //         params: {
        //             // period에 따라 month 또는 year를 보낸다고 가정
        //             month: period === 'monthly' ? `${selectedYear}-${String(selectedMonth).padStart(2, '0')}` : '',
        //             year: selectedYear
        //         }
        //     });

        //     let tmp = response?.data;
        //     console.log(tmp)
        //     if (tmp?.code < 2000) {
        //         // 가맹점 데이터 저장
        //         setMerchantListData(tmp?.data ?? []);

        //         // (1) dailyData / monthData를 여기서 세팅
        //         if (period === 'monthly') {
        //             // dailyData로 사용
        //             const dailyResult = (tmp?.data ?? []).map(d => ({
        //                 date: d.date,
        //                 amt: d.agencyAmount // 그래프용 amt
        //             }));
        //             setDailyData(dailyResult);
        //             setMonthData([]); // 초기화
        //         } else {
        //             // monthData로 사용
        //             const monthResult = (tmp?.data ?? []).map(d => ({
        //                 month: d.date?.slice(0, 7), // 예시로 date 중 YYYY-MM 부분만 추출
        //                 amt: d.agencyAmount
        //             }));
        //             setMonthData(monthResult);
        //             setDailyData([]); // 초기화
        //         }
        //         setListState(e => !e);
        //     } else if (tmp?.code === 9999) {
        //         navigate('/');
        //     }
        // } catch (error) {
        //     console.error(error);
        //     navigate('/');
        // }
    };

    const tableHeaderData1 = [
        { "no": 1, "text": "날짜", "width": "80px", "textAlign": "center" },
        { "no": 2, "text": "정산금액", "width": "200px", "textAlign": "center" },
    ];

    // agentSettlement가 갱신될 때마다 연도 리스트 및 가장 최근 연도 추출
    useEffect(() => {
        if (!agentSettlement || agentSettlement.length === 0) return;

        // "YYYY-MM"에서 "YYYY"만 추출하고 중복 제거
        const years = agentSettlement
            .map(item => item.month.split("-")[0]) // "YYYY-MM"에서 "YYYY" 추출
            .filter((year, idx, arr) => arr.indexOf(year) === idx) // 중복 제거
            .sort((a, b) => parseInt(b) - parseInt(a)); // 오름차순 정렬

        setYearList(years);

        // 가장 높은 연도를 기본값으로 설정
        const latestYear = Math.max(...years.map(yr => parseInt(yr)));
        setSelectedYear(String(latestYear));
    }, [agentSettlement]);

    // agentSettlement 또는 selectedYear가 바뀔 때마다 테이블 데이터 생성
    useEffect(() => {
        if (!agentSettlement || agentSettlement.length === 0 || !selectedYear) {
            setCombineData([]);
            return;
        }

        // selectedYear로 필터링
        const filtered = agentSettlement.filter(item =>
            item.month.startsWith(selectedYear)
        );

        let tableBodyData = filtered.map((data) => ([
            { "no": 1, "text": data.month, "width": "80px", "textAlign": "center" },
            { "no": 2, "text": `${changeNum(Number(data.total_fee))}원`, "width": "200px", "textAlign": "right" },
        ]));

        setCombineData(tableBodyData);
        setPage(1); // 다른 연도 선택 시 페이지를 1로 초기화
    }, [agentSettlement, selectedYear]);

    let filter_tableBodyData = combineData.slice((page - 1) * 12, page * 12);

    const [dropdown, setDropdown] = useState(false)

    return (
        <div className="flex overflow-hidden">
            <div className="content" id="contents">
                <div className="inner-wrap dashboard">
                    <div className="content-container c-left sales">
                        <div className="content-wrap" style={{ paddingBottom: "40px" }}>
                            <div className="content-item">
                                <div className="main-title-wrap" style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                    <h2 className="title">익일정산</h2>
                                </div>
                                <div className="agent_panel">
                                    <div className="panel agent_panel-1">
                                        <ul>
                                            <li style={{ justifyContent: "flex-end", alignItems: "flex-end" }} onClick={() => setDropdown(e => !e)}>
                                                <money id="yesterdayTotalAmount" style={{ fontSize: "3.3rem", height: "45px", lineHeight: "45px", fontWeight: "500" }}>
                                                    {changeNum(agentDashboardToday?.trade_amount ?? 23123123)}
                                                </money>
                                                {
                                                    dropdown
                                                        ?
                                                        <ChevronUp />
                                                        :
                                                        <ChevronDown />
                                                }
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {
                                    dropdown && (
                                        <div className="agent_panel">
                                            <div className="panel agent_panel-2">
                                                <ul>
                                                    <li style={{ display: "block" }}>
                                                        <strong className="truncate calc-title">승인액</strong>
                                                        <p className="calc-item" id="">
                                                            <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.agent_count ?? 123234123)}</money>
                                                            <span>원</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li style={{ display: "block" }}>
                                                        <strong className="truncate calc-title">취소액</strong>
                                                        <p className="calc-item" id="">
                                                            <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.merchant_count ?? 123234123)}</money>
                                                            <span>원</span>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                            </div>

                            {/* 실시간 매출 현황 */}
                            {/* <div className="content-item">
                                <div className="main-title-wrap" style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                    <h2 className="title">실시간 현황</h2>
                                </div>
                                <div className="agent_panel">
                                    <div className="panel agent_panel-2">
                                        <ul>
                                            <li style={{ display: "block" }}>
                                                <strong className="truncate calc-title">승인액</strong>
                                                <p className="calc-item" id="">
                                                    <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.agent_count ?? 123234123)}</money>
                                                    <span>원</span>
                                                </p>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li style={{ display: "block" }}>
                                                <strong className="truncate calc-title">정산예상금액</strong>
                                                <p className="calc-item" id="">
                                                    <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.merchant_count ?? 123123123)}</money>
                                                    <span>원</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                            {/* 가맹점 정산 */}
                            <div className="content-item">
                                <div className="main-title-wrap" style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                    <h2 className="title">정산</h2>
                                </div>

                                <div className="content-item">
                                    <div className="panel intro-y" style={{ width: "100%" }}>
                                        <div style={{ width: '100%', height: '100%' }}>
                                            <div className="main-title-wrap intro-y dashboard-graph" style={{ borderBottom: "none" }}>
                                                <div style={{ display: 'flex', gap: '10px' }}>
                                                    {/* 라디오버튼: 'monthly' => 일별, 'yearly' => 월별 */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <label
                                                                style={{
                                                                    marginRight: 5,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    value="monthly"
                                                                    checked={period === 'monthly'}
                                                                    onChange={(e) => setPeriod(e.target.value)}
                                                                />
                                                                <span style={{ marginLeft: 3, paddingTop: 1 }}>
                                                                    월별
                                                                </span>
                                                            </label>

                                                            <label
                                                                style={{
                                                                    marginRight: 5,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    value="yearly"
                                                                    checked={period === 'yearly'}
                                                                    onChange={(e) => setPeriod(e.target.value)}
                                                                />
                                                                <span style={{ marginLeft: 3, paddingTop: 1 }}>
                                                                    연도별
                                                                </span>
                                                            </label>
                                                        </div>

                                                        {/* 년도 + 월 셀렉트 */}
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '5px',
                                                            }}
                                                        >
                                                            <select
                                                                id="check_gubun"
                                                                name="check_gubun"
                                                                className="form-select"
                                                                aria-label="Default select example"
                                                                style={{
                                                                    height: '30px',
                                                                    padding: '0 10px',
                                                                    fontSize: '12px',
                                                                    width: '70px',
                                                                }}
                                                                value={selectedYear}
                                                                onChange={(e) => {
                                                                    const newYear = parseInt(e.target.value, 10);
                                                                    setSelectedYear(newYear);
                                                                    if (newYear < currentYear && selectedMonth > 12) {
                                                                        setSelectedMonth(12);
                                                                    }
                                                                }}
                                                            >
                                                                {yearList
                                                                    .slice()
                                                                    .reverse()
                                                                    .map((y) => (
                                                                        <option key={y} value={y}>
                                                                            {String(y).substring(2)}년
                                                                        </option>
                                                                    ))}
                                                            </select>

                                                            {period === 'monthly' && (
                                                                <select
                                                                    id="check_gubun"
                                                                    name="check_gubun"
                                                                    className="form-select"
                                                                    aria-label="Default select example"
                                                                    style={{
                                                                        height: '30px',
                                                                        padding: '0 10px',
                                                                        fontSize: '12px',
                                                                        width: '70px',
                                                                    }}
                                                                    value={selectedMonth}
                                                                    onChange={(e) =>
                                                                        setSelectedMonth(parseInt(e.target.value, 10))
                                                                    }
                                                                >
                                                                    {monthList
                                                                        .slice()
                                                                        .reverse()
                                                                        .map((m) => (
                                                                            <option key={m} value={m}>
                                                                                {m}월
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 매출 그래프 컴포넌트 */}
                                            <List
                                                tableHeaderData={tableHeaderData1}
                                                tableBodyData={combineData}
                                                filter_tableBodyData={filter_tableBodyData}
                                                page={page}
                                                setPage={setPage}
                                                maxFirstPage={12}
                                                height={"auto"}
                                                nonePage={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function MainModal({ data = [], period }) {
    // 날짜 라벨 포맷 함수 ("2025-03-01" → "25-03-01")
    const formatDateLabel = (val) => {
        if (!val) return '';
        return val.slice(2);
    };

    // 전체 카테고리 생성: 연별 12개월 또는 해당 월의 모든 일
    let rawCategories = [];
    if (period === 'monthly') {
        const firstDate = data[0]?.date;
        const [year, month] = firstDate
            ? firstDate.split('-')
            : [String(new Date().getFullYear()), String(new Date().getMonth() + 1).padStart(2, '0')];
        const daysInMonth = new Date(year, parseInt(month, 10), 0).getDate();
        rawCategories = Array.from({ length: daysInMonth }, (_, i) => {
            const day = String(i + 1).padStart(2, '0');
            return `${year}-${month.padStart(2, '0')}-${day}`;
        });
    } else {
        const firstMonth = data[0]?.month;
        const year = firstMonth ? firstMonth.split('-')[0] : String(new Date().getFullYear());
        rawCategories = Array.from({ length: 12 }, (_, i) => {
            const m = String(i + 1).padStart(2, '0');
            return `${year}-${m}`;
        });
    }

    // X축 표시용 라벨
    const categories = rawCategories.map(val => formatDateLabel(val));

    // Y값: 데이터가 없으면 null로 반환 -> ApexCharts가 포인트를 건너뜀
    const seriesData = rawCategories.map(val => {
        const found =
            period === 'monthly'
                ? data.find(item => item.date === val)
                : data.find(item => item.month === val);
        return found ? parseFloat(found.amt) : null;
    });

    // ApexCharts 옵션
    const options = {
        chart: { height: 350, type: 'line' },
        dataLabels: { enabled: false },
        stroke: {
            width: 2,
            curve: 'smooth',         // 'straight'에서 'smooth'로 변경하여 부드러운 곡선으로 표현
            connectNulls: false,
        },
        xaxis: {
            categories,
            labels: { rotate: -60, hideOverlappingLabels: true },
            title: { text: '매출그래프', style: { fontSize: '14px', fontWeight: 600 } },
        },
        yaxis: {
            min: 0,
            labels: {
                formatter: value =>
                    Math.floor(value)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            },
        },
        tooltip: {
            y: {
                formatter: val =>
                    val === null
                        ? ''
                        : val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원',
            },
        },
        legend: { position: 'top' },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    xaxis: { tickAmount: 4, labels: { rotate: -90 } },
                    yaxis: { show: false, labels: { show: false } },
                },
            },
        ],
    };

    const series = [
        { name: period === 'monthly' ? '일별 매출' : '월별 매출', data: seriesData },
    ];

    return (
        <div className="marginTop30 modal_sty">
            <div style={{ height: 'auto', padding: '10px 0' }}>
                <Chart options={options} series={series} type="line" height={300} />
            </div>
        </div>
    );
}
export default Dashboard;